export class NotificationMessage {
  key: string;
  title: string;
  message: string;
  type: string;
}
